import type { AuthUser, UserCredential } from "@/infrastructure/firebase/firebaseAuthService";
import firebaseAuthService from "@/infrastructure/firebase/firebaseAuthService";

/**
 * Authentication service interface
 */
export interface AuthService {
    getCurrentAuthUser(): AuthUser | null;
    onAuthStateChanged(callback: (user: AuthUser | null) => void): () => void;
    signIn(email: string, password: string): Promise<UserCredential>;
    signOut(): Promise<void>;
}

/**
 * Authentication service for user authentication operations.
 *
 * Provides a unified interface for user authentication including sign-in
 * and session management using the Firebase Auth Service.
 */
const authService: AuthService = {
    // Get current user
    getCurrentAuthUser() {
        return firebaseAuthService.getCurrentAuthUser();
    },

    // Subscribe to authentication state changes
    onAuthStateChanged(callback: (user: AuthUser | null) => void): () => void {
        return firebaseAuthService.onAuthStateChanged(callback);
    },

    // Sign in with email and password
    async signIn(email: string, password: string): Promise<UserCredential> {
        return await firebaseAuthService.signInWithEmailAndPassword(email, password);
    },

    // Sign out current user
    async signOut(): Promise<void> {
        return await firebaseAuthService.signOut();
    },
};

export default authService;
